module.exports = __webpack_public_path__ + "static/media/image_5.69ff240f.png";